import { clearAppErrorSessionStorage } from '@/helpers/appErrorSession';
import { ROUTE_ALIASES } from '@/routing/routesAliases';
import AuthService from '@/services/auth.service';
import { impersonationService } from '@/services/impersonation.service';
import SuperAdminsService from '@/services/super-admins.service';

const teardownSessionAndRedirect = async ({ redirectUrl }: { redirectUrl: string | null }): Promise<void> => {
  // Prevent auth guards from auto-starting a new Cognito sign-in while we tear
  // down the session; otherwise the signinRedirect race can override the
  // redirect back to the control center.
  AuthService.setLogoutIntent();

  const wasImpersonating = impersonationService.getSession().isImpersonating;
  impersonationService.clearSession();

  try {
    if (wasImpersonating) {
      await SuperAdminsService.revokeCurrentChurchAdminAccess();
    }
  } catch (_) {
    // Continue cleanup even when revoke fails so the user can leave the session.
  } finally {
    clearAppErrorSessionStorage();
    // Impersonation handoff tokens are revoked server-side above; Cognito /oauth2/revoke
    // returns 401 for those tokens and must not run during teardown.
    await AuthService.clearLocalAuthSession({ skipTokenRevoke: wasImpersonating });
  }

  if (redirectUrl) {
    window.location.assign(redirectUrl);
    return;
  }

  AuthService.clearLogoutIntent();
  window.location.assign(`${ROUTE_ALIASES.LOGIN}?logged_out=1`);
};

const endSession = async (): Promise<void> => {
  const redirectUrl = impersonationService.getStopRedirectUrl();
  await teardownSessionAndRedirect({ redirectUrl });
};

export const impersonationSessionService = {
  endSession,
};
